import Layout from './Layout'

const Home = () => {
    return (
        <Layout>
            <div style={{textAlign: 'center'}}>
                <a href="https://www.bitcoinislandproject.com/">Bitcoin Island Project</a>
            </div>
        </Layout>
    )
}

export default Home
